// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2Fae3","errorLogs":"EditorFooter_errorLogs__30cYj"};